module.exports = __webpack_public_path__ + "img/img59.141ee652.svg";